module.exports = __webpack_public_path__ + "static/Ribs-Usa-Menu-08b03d805aaaa964356a6728afc1b052.pdf";